import React, { Component } from "react";
import TldrBase from "../TldrLogin/TldrBase";
import { Box, Button } from "@chakra-ui/react";
import { FaUndo } from "react-icons/fa";
import { withTranslation } from "react-i18next";
import { analyticsTrackEvent } from "../_utils/common";

class TLDRChunkLoadError extends Component {
  onRefreshPage = () => {
    if (window) {
      window.location.reload();
      analyticsTrackEvent("app-update", {
        appVersion: process.env.REACT_APP_VERSION,
      });
    }
  };

  render() {
    const { t } = this.props;

    return (
      <TldrBase
        heading={t("update_application.heading")}
        subheading={t("update_application.subheading")}
      >
        <Box display="flex" justifyContent="center">
          <Button
            leftIcon={<FaUndo />}
            colorScheme="primary"
            variant="link"
            onClick={(event) => this.onRefreshPage()}
          >
            {t("update_application.cta")}
          </Button>
        </Box>
      </TldrBase>
    );
  }
}

export default withTranslation(["common"])(TLDRChunkLoadError);
